import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useNavigate } from 'react-router-dom'

import img_arrow from '../../../assets/images/right.svg'
import training_img from '../../../assets/images/folders/training.svg'
import folder_img from '../../../assets/images/folders/folder.svg'
import lesson_img from '../../../assets/images/folders/lesson.svg'
import edit_img from '../../../assets/images/edit.svg'

import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { forwardRef, useEffect, useMemo, useState } from 'react'
import { fetchGetSubFolders } from '../FolderApi'
import { toast } from 'react-toastify'
import { API_URL, EXAMS_STATUS } from '../../../config/constants'


export default function Folder ({folder, hasContent, isDragging}){

    const t = useSelector(selectTranslations)
    const [subFoldersCount, setSubfoldersCount] = useState(0)
    const navigate = useNavigate()

    const openFolder = () =>{
        navigate(`/folder/${folder.folder_id}`, {replace: true})
    }

    const loadSubFolders = async () => {
        const response = await fetchGetSubFolders({parent_folder_id: folder?.folder_id})
        if (response.success){
            setSubfoldersCount(response.data?.folders?.length)
        } else {
            toast.error(t.training.error_loading_folder)
        }
    } 

    useMemo(( )=>{
        if(folder && folder.folder_id && !isDragging)
            loadSubFolders()
    },[folder])


    const content = ( ) => {
        let _count = 0
        _count = _count + (folder?.videos?.length || 0)
        _count = _count + (folder?.files?.length || 0)
        _count = _count + (folder?.links?.length || 0)
        return _count
    }

    return(
        <div className={`folder pointer h-100`} onClick={openFolder}>
            <div className='folder__content h-100'>
                {
                    folder ? 
                    <>
                        <div className='d-flex justify-content-between align-items-start'>
                            <h3>{folder?.icon_url && <img className='folder_icon me-1' src={`${API_URL}${folder.icon_url}`} />}
                            {folder?.name}</h3> 
                            <span className='status_label' style={{color:`${EXAMS_STATUS[folder?.state]?.color}`, background: `${EXAMS_STATUS[folder?.state]?.background}`}}>
                                {folder?.state === "draft" && <img src={edit_img} className='me-1' style={{maxWidth:'18px', verticalAlign:'middle'}}/>}
                                {t.folder.state[folder?.state]}
                            </span> 
                        </div>
                        <hr />
                        <div className='d-flex justify-content-between mt-3 align-items-end'>
                            <div>
                                {folder.training ?
                                <span className='d-block'>
                                    <img className='me-1' src={training_img} style={{verticalAlign:'sub'}}/>
                                    <span><strong>1</strong> {t.training.training}</span>
                                </span> : null }
                                {subFoldersCount !== 0 ?
                                <span className='d-block mt-1'>
                                    <img className='me-1' src={folder_img} style={{verticalAlign:'sub'}}/>
                                    <span><strong>{subFoldersCount}</strong> {t.training.folders}</span>
                                </span> : null}
                                {content() > 0 ?
                                <span className='d-block mt-1'>
                                    <img className='me-1' src={lesson_img} style={{verticalAlign:'sub'}} />
                                    <span><strong>{content()}</strong> {t.training.materials}</span>
                                </span> : null}
                            </div>
                            <span onClick={openFolder} className='text-tf'>
                                <u>{t.folder.edit}
                                <img src={img_arrow} className='pointer' alt="" /></u>
                            </span>
                        </div>
                        
                    </> : <>
                        <Skeleton count={2}/>
                    </>
                }
            </div>
        </div>
    )
}